import React from 'react';
import { faUserMd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './HealthSymptoms';
import HealthSymptoms from './HealthSymptoms';
import HealthTips from './HealthTips';
import '../styles/Health.css';

function Health() {
  return (
    <section id="health-container">
      <h2 className="health-tips-title">
        Health Tips <FontAwesomeIcon icon={faUserMd} size="2x" />
      </h2>
      <div id="health-tips">
        <HealthTips />
      </div>

      <section id="health-symptoms">
        <h1 id="health-symptoms-title">Covid-19 Symptoms</h1>
        <div id="symptoms-list">
          <HealthSymptoms />
        </div>
        <a
          className="learn-more"
          href="https://www.cdc.gov/coronavirus/2019-ncov/index.html">
          Click here to learn more about Covid-19
        </a>
      </section>
    </section>
  );
}

export default Health;
